import type { CounterConfig } from "@/lib/schema";
import type { WidgetSettingsEditorProps } from "@/widgets/types";

type Props = WidgetSettingsEditorProps<CounterConfig>;

export function SettingsEditor({
  config,
  onChange,
  errors = {},
  scoringField,
}: Props) {
  const fieldError = (key: string) =>
    errors[key] ? (
      <p className="field-error" data-testid={`widget-error-${key}`}>
        {errors[key]}
      </p>
    ) : null;

  return (
    <div
      className="widget-settings"
      data-testid={`widget-settings-${config.id}`}
    >
      <div className="setting-row">
        <label className="setting-label" htmlFor={`label-${config.id}`}>
          Tittel
        </label>
        <div className="setting-control">
          <input
            id={`label-${config.id}`}
            className="input"
            type="text"
            value={config.label}
            onChange={(e) => onChange({ label: e.target.value })}
            data-testid="widget-label-input"
          />
          {fieldError("label")}
        </div>
      </div>

      <div className="setting-row">
        <label className="setting-label" htmlFor={`points-${config.id}`}>
          Poeng
          <small>Poeng per enhet.</small>
        </label>
        <div className="setting-control">
          <div className="num-input">
            <input
              id={`points-${config.id}`}
              type="number"
              min={1}
              value={config.points}
              onChange={(e) =>
                onChange({ points: Math.max(0, Number(e.target.value) || 0) })
              }
              data-testid="widget-points-input"
            />
            <span className="unit">p</span>
          </div>
          {fieldError("points")}
        </div>
      </div>

      <div className="setting-row">
        <label className="setting-label" htmlFor={`max-points-${config.id}`}>
          Maks per dag
          <small>
            Flest poeng én dag kan gi, så ingen enkeltdag dekker for uken.
            Telleren stopper her, og dagen blir ferdiglogget.
          </small>
        </label>
        <div className="setting-control">
          <div className="num-input">
            <input
              id={`max-points-${config.id}`}
              type="number"
              min={1}
              value={Number.isFinite(config.maxPoints) ? config.maxPoints : ""}
              onChange={(e) => {
                const v = e.target.value;
                onChange({
                  maxPoints:
                    v === "" ? Number.NaN : Math.max(0, Number(v) || 0),
                });
              }}
              data-testid="counter-max-points-input"
            />
            <span className="unit">p</span>
          </div>
          {fieldError("maxPoints")}
        </div>
      </div>

      {scoringField}
    </div>
  );
}
